module.exports = __webpack_public_path__ + "img/department_icon4.bbdb26d2.png";